import { render, staticRenderFns } from "./_documents_col.vue?vue&type=template&id=d7e9cf72&"
import script from "./_documents_col.vue?vue&type=script&lang=js&"
export * from "./_documents_col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports